module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAMAAADypuvZAAAAAXNSR0IArs4c6QAAAEVQTFRFAAAA////i4uLiIiIgICJgICEfoGBgICDfoGBfoGBfoGBfn6BfX+AfX+AfoCBfn6Bfn6Bfn+AfX6BfX6Bfn+Afn+AfX6Ai4oTSwAAABZ0Uk5TAAELDxw6RUpLTU9Vo6Wmqr7R4Obt8R0cCCwAAACPSURBVEjH7ZbLCoAgEEWtrOxlZub/f2pitTAcGIUkyrty4WGUOYtLSMpQvmpkVk5PRumAqIPiOijcQuZtLfYnzLzQHgyN//91+cNQ1Q/+dCUMLeBmBAgVGwhJeFIzzf6M9b/2lI3IRrzCCMcCgjVCoKCbERI3yTHCsSAvN0MPQaZ8sODyEVVzogpVVHVLlB2Xqj9tD2fOAwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/assets/images/article-icon.png
// module id = eM4U
// module chunks = 243